import { render } from "./SelectColor.vue?vue&type=template&id=33ad31dd&ts=true"
import script from "./SelectColor.vue?vue&type=script&lang=ts"
export * from "./SelectColor.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__